import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

interface rankingSelectionTrackingPayload {
    city: string;
    year: string;
    isForm?: boolean;
}

export const rankingSelectionTracking = (payload: rankingSelectionTrackingPayload) => {
    const data = {
        event: "rankings",
        event_action: payload.isForm ? "select" : "click",
        event_label: payload.isForm ? "list" : "tile",
        event_category: payload.city,
        event_category2: payload.year
    };

    hitGoogleTagManager(data);
};
